module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/180-french-polynesia-4a5f848efcd0e49a005e1f12058dc950.svg";